import global from "../../styles";
import styles from "./styles";
import Decoration from "../decoration";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const LevelUp = ({ assetsUrl }) => {
  const translate = useTranslate(useLocaleProvider());
  const header = translate("loyalty_landing_page_charms_header");
  return (
    <div className={styles.levelUpImageContainer}>
      <picture className={styles.levelUpImage}>
        <source
          srcSet={`${assetsUrl}/level-up-desktop_claqcw`}
          media="(min-width: 480px)"
          width="100%"
        />
        <img
          src={`${assetsUrl}/level-up-mobile_yocaux`}
          alt="connect"
          width="100%"
          loading="lazy"
        />
      </picture>
      <div>
        <div
          className={classNames(styles.levelUpContainer, global.rightAlignment)}
        >
          <Decoration
            width="121"
            height="16"
            className={global.desktopAndTablet}
          />
          <Decoration
            width="60"
            height="24"
            className={global.desktopAndTablet}
          />
          <Decoration width="32" height="24" className={global.mobileOnly} />
          <Decoration width="187" height="16" />
          <h2
            className={classNames(styles.header, global.headerASOSWorld)}
            aria-label={header}
          >
            {header}
          </h2>
          <Decoration
            width="84"
            height="24"
            className={global.desktopAndTablet}
          />
          <div
            className={classNames(
              global.leavesden1,
              styles.description,
              global.textBackground
            )}
          >
            {translate("loyalty_landing_page_charms_body")}
          </div>
          <Decoration
            width="330"
            height="72"
            className={global.mobileOnly}
            x="0"
            y="-160"
          />
          <Decoration
            width="95"
            height="16"
            className={global.mobileOnly}
            x="0"
            y="-73"
          />
        </div>
      </div>
    </div>
  );
};

export default LevelUp;

LevelUp.propTypes = {
  assetsUrl: PropTypes.string,
};
